import { useQuery } from '@tanstack/react-query';
import { glossaryService } from '../services/glossaryService';

export const useGlossaryTerms = () => {
  return useQuery({
    queryKey: ['glossary', 'terms'],
    queryFn: () => glossaryService.getAllTerms(),
    staleTime: 24 * 60 * 60 * 1000, // 24 hours - glossary rarely changes
  });
};

export const useGlossaryTerm = (id: number) => {
  return useQuery({
    queryKey: ['glossary', 'term', id],
    queryFn: () => glossaryService.getTermById(id),
    staleTime: 24 * 60 * 60 * 1000,
  });
};

export const useGlossaryTermByName = (term: string | null) => {
  return useQuery({
    queryKey: ['glossary', 'term-by-name', term],
    queryFn: () => glossaryService.getTermByName(term!),
    enabled: !!term,
    staleTime: 24 * 60 * 60 * 1000,
  });
};

export const useGlossaryCategories = () => {
  return useQuery({
    queryKey: ['glossary', 'categories'],
    queryFn: () => glossaryService.getCategories(),
    staleTime: 24 * 60 * 60 * 1000,
  });
};

export const useGlossaryTermsByCategory = (category: string | null) => {
  return useQuery({
    queryKey: ['glossary', 'category', category],
    queryFn: () => glossaryService.getTermsByCategory(category!),
    enabled: !!category,
    staleTime: 24 * 60 * 60 * 1000,
  });
};

export const useGlossarySearch = (query: string) => {
  return useQuery({
    queryKey: ['glossary', 'search', query],
    queryFn: () => glossaryService.searchTerms(query),
    enabled: query.length >= 2,
    staleTime: 5 * 60 * 1000, // 5 minutes for search results
  });
};
